// src/redux/productSlice.js

import { createSlice } from "@reduxjs/toolkit";

// Initial state for products
const initialState = {
  products: [], // Store the list of products
  loading: false,
  error: null,
};

// The Redux slice (state and reducers)
const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    fetchProductsStart: (state) => {
      state.loading = true;
    },
    fetchProductsSuccess: (state, action) => {
      state.products = action.payload;
      state.loading = false;
    },
    fetchProductsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    addProduct: (state, action) => {
      state.products.push(action.payload);
    },
    deleteProduct: (state, action) => {
      state.products = state.products.filter(
        (product) => product.id !== action.payload
      );
    },
  },
});

// Export actions for use in components
export const {
  fetchProductsStart,
  fetchProductsSuccess,
  fetchProductsFailure,
  addProduct,
  deleteProduct,
} = productSlice.actions;

// Export the reducer to be used in the store
export default productSlice.reducer;
